import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'
import cx from 'classnames'
import moment from 'moment'

import ParticipationElement from './components/ParticipationElement'
import ParticipationHeader from './components/ParticipationHeader'

import './style.scss'

export default class RoleTable extends Component {
    static propTypes = {
        block: PropTypes.string,
        clickedElement: PropTypes.object,
        customData: PropTypes.object,
        dateRange: PropTypes.object.isRequired,
        handleOnHover: PropTypes.func.isRequired,
        hoveredElement: PropTypes.object.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string,
        openSections: PropTypes.object.isRequired,
        pinnedIndex: PropTypes.string,
        pinParticipationElement: PropTypes.func.isRequired,
        roles: PropTypes.array,
        tableIdentifier: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            today: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    static defaultProps = {
        roles: [],
    }

    everyParticipationInactive = (participation) => _.every(participation, { inactive: true })

    render() {
        const {
            mainId,
            pinnedIndex,
            roles,
            dateRange,
            hoveredElement,
            module,
            block,
            customData,
            handleOnHover,
            tableIdentifier,
            openSections,
            clickedElement,
            translates: { today, from, to },
            pinParticipationElement,
        } = this.props

        if (!_.get(openSections, `${tableIdentifier}`)) return null

        const timelineStartDate = moment(_.get(dateRange, 'startDate.value', null)).startOf('year')
        const timelineEndDate = moment(_.get(dateRange, 'endDate.value', null))
        // Difference between start and end of timeline in days
        const timelineDurationInDays = timelineEndDate.diff(timelineStartDate, 'days')

        return (
            <div className={'role-table'}>
                <div className={cx('role-table-row', 'first')}>
                    <div className={'role-table-border'} />
                    <div className={'role-table-navigation'}>
                        <div className={'table-nav-top-elem'} />
                    </div>
                    <div className={'role-table-label'} />
                    <ParticipationHeader
                        endYear={timelineEndDate}
                        startYear={timelineStartDate}
                        step={dateRange.step}
                        translates={{ today }}
                    />
                </div>
                {_.map(roles, ({ name, participation }, key) => (
                    <div
                        key={`role-table-row-${key}`}
                        className={cx('role-table-row', key === roles.length - 1 && 'last')}
                    >
                        <div className={'role-table-border'} />
                        <div className={'role-table-navigation'}>
                            <div className={'table-nav-top-elem'} />
                            <div className={'table-nav-bottom-elem'} />
                        </div>
                        <div
                            className={cx(
                                'role-table-label',
                                this.everyParticipationInactive(participation) && 'inactive'
                            )}
                        >
                            <span>{name}</span>
                        </div>
                        <div className={'role-table-line'}>
                            {!_.isEmpty(hoveredElement) && (
                                <div
                                    style={{ left: `${hoveredElement.left}%`, width: `${hoveredElement.width}%` }}
                                    className={'line-hover'}
                                />
                            )}
                            {!_.isEmpty(clickedElement) && pinnedIndex && (
                                <div
                                    style={{ left: `${clickedElement.left}%`, width: `${clickedElement.width}%` }}
                                    className={'line-hover'}
                                />
                            )}
                            <div className={'line-inside'} />
                            {participation &&
                                _.map(participation, ({ startDate, endDate, inactive }, participationKey) => (
                                    <ParticipationElement
                                        module={module}
                                        block={block}
                                        customData={customData}
                                        translates={{ from, to }}
                                        mainId={mainId}
                                        name={name}
                                        inactive={inactive}
                                        pinnedIndex={pinnedIndex}
                                        key={`participation-${participationKey}`}
                                        timelineDurationInDays={timelineDurationInDays}
                                        startDate={_.get(startDate, 'value', null)}
                                        endDate={_.get(endDate, 'value', null)}
                                        timelineStartDate={timelineStartDate}
                                        timelineEndDate={timelineEndDate}
                                        handleOnHover={handleOnHover}
                                        index={`${tableIdentifier}-${key}-${participationKey}`}
                                        pinParticipationElement={pinParticipationElement}
                                    />
                                ))}
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
